import React from "react";
import ScrollContainer from "react-indiana-drag-scroll";

import { formatNumber } from "utils";

import { Col, Icon, Link, Row } from "components";

export const CourseInfo = ({ course, t }) => (
  <section className="container content mini padded-top">
    <Row>
      <Col>
        <h4>{t("courseOverview.methods")}</h4>
        <div className="tag-container">
          <ScrollContainer className="tag-list">
            {course.methods
              .filter((method) => method)
              .map((method, i) => (
                <Link to={`/search/articles/${method.link}`} key={i}>
                  #{method.title}
                </Link>
              ))}
          </ScrollContainer>
        </div>
      </Col>
    </Row>
    <Row>
      <Col>
        <div className="statistics">
          <div className="statistic">
            <Icon iconName="tabler/clock" />
            <div>
              &#177;{" "}
              {t("courseOverview.duration", {
                duration: formatNumber({
                  number: course.duration / 3600,
                  decimalPlaces: 1,
                }),
              })}
            </div>
          </div>
          <div className="statistic">
            <Icon iconName="tabler/movie" />
            <div>{t("courseOverview.videos", { count: course.videos })}</div>
          </div>
          <div className="statistic">
            <Icon iconName="tabler/news" />
            <div>{t("courseOverview.articles", { count: course.articles })}</div>
          </div>
        </div>
      </Col>
    </Row>
  </section>
);
